module.exports = "/_next/static/images/Bulat_Oleg-72d6ee1db2b2937c8483dd5d8020fa97.webp";